
import produce from "immer";

import types from "./types";

const INITIAL_STATE = {
  behavior: "create",
  components: {
    drawer: false,
    confirmDelete: false,
  },

  form: {
    filtering: false,
    disabled: true,
    saving: false,
    errorTag:"",
    fail: false,
   
    saveDataForm:false,
    decode:"",
    messageError:"",
    type:"",
    result:false,
  },  
  steps:{id:1},
  step1:{
    email: "",
    name: "",
    phone_number: "",
    
  },
  code:{
    id:""
  },
  auth:{
id:""  },
  codeOk:{id: false},

  step2:{
    id: null,
    cpf: "",
    address: "",
    address_number: "",
    address_complement: "",
    address_district: "",
    address_city: "",
    address_state: "",
    address_zipcode: "",
    password:""
  },
  clientes: [],
  user: {
    nome: "",
    email: "",
    telefone: "",
    dataNacimento: "",
    sexo: "M",
    cpf: "",
    cnh: "",
    cidade: "",
    uf: "",
    cep: "",
    logradouro: "",
    numero: "",
    pais: "BR",
    vinculoId: "ALSDKJF1123",
  },
  cliente: {
    id: null,
    name: "",
    email: "",
    cpf: "",
    phone_number: "",
    address: "",
    address_number: "",
    address_complement: "",
    address_district: "",
    address_city: "",
    address_state: "",
    address_zipcode: "",
    password: "",   
    active: false,
    isAdmin:false,
    hasLicense:"",
    validLicense:false,
  },
  users_licenses: {
    id: "",
    photo: "",
    number: "",
    valid_to: "",
    category: "",
    users_id: "",
    active: "",
  },
  users_cost_centers: {
    users_id: null,
    cost_centers_id: null,
  },
  cost_centers: {
    id: null,
    name: "",
    active: false,
    areas_id: null,
  },
  areas: {
    id: null,
    name: "",
    active: false,
  },
  vehicles: {
    id: null,
    license: "",
    model: "",
    odometer: null,
    consumption: null,
    photo: "",
    active: false,
    brands_id: null,
    status: "",
  },
  brands: {
    id: null,
    name: "",
    active: false,
  },
  loginCliente: {
    email: "",
    password: "",
  },
};

function cliente(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.UPDATE_CLIENTE: {
      return produce(state, (draft) => {
        draft = { ...draft, ...action.payload };
        return draft;
      });
    }
    case types.RESET_CLIENTES: {
      return produce(state, (draft) => {
        draft.cliente = INITIAL_STATE.cliente;
        return draft;
      });
    }
    case types.RESET_STEP1: {
      return produce(state, (draft) => {
        draft.step1 = INITIAL_STATE.step1;
        return draft;
      });
    }
    case types.RESET_STEP2: {
      return produce(state, (draft) => {
        draft.step2 = INITIAL_STATE.step2;
        return draft;
      });
    }

    default:
      return state;
  }
}

export default cliente;
